import AdFormService from './services/AdFormService';
import PageData from './PageData';
import ProjectUnitsService from './services/ProjectUnitsService';
import ContactModal from './components/modals/ContactModal';

export default class ProjectUnitsTabs {
  private tabs: Array<HTMLElement>;

  private saleTabContent: HTMLElement;

  private projectPagePath: string;

  private readonly rentTabContent: HTMLElement;
  private readonly loader: HTMLElement | null;

  private readonly pageData: PageData;

  private readonly publisherId: string;

  private readonly isNewDevelopment?: boolean;

  constructor(pageData: PageData) {
    this.tabs = Array.from(document.querySelectorAll(
      'div[data-unittab="true"]',
    ));
    this.saleTabContent = document.querySelector('div[data-contentid="units-for-sale-content"]') as HTMLElement;
    this.rentTabContent = document.querySelector('div[data-contentid="units-for-rent-content"]') as HTMLElement
    this.loader = document.getElementById('loading-units');
    this.publisherId = document.querySelector('[data-publisherid]') ? (document.querySelector('[data-publisherid]') as HTMLElement).dataset.publisherid! : '';
    this.isNewDevelopment = document.querySelector('[data-isnewdevelopment]') ? (document.querySelector('[data-isnewdevelopment]') as HTMLElement).dataset.isnewdevelopment === 'true' : undefined;
    this.pageData = pageData;
    this. projectPagePath = "project";
    if(pageData.brand.toLowerCase() == "properati" ) {
      if (pageData.country == "AR") {
        this.projectPagePath = "emprendimiento"
      } else {
        this.projectPagePath = "proyecto"
      }
    }

    if (document.getElementById('units-for-sale-content')) {
      this.selectTab(this.saleTabContent);
    } else if (document.getElementById('units-for-rent-content')) {
      this.selectTab(this.rentTabContent);
    }
  }

  setupEventListeners = () => {
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        this.selectTab(tab);
      });
    });
  };

  private selectTab = (tab: HTMLElement) => {
    const idOfContentElement: string = tab.dataset.contentid!;
    const tabContent = document.getElementById(idOfContentElement);
    this.clearSelection();
    this.showLoader();
    tab.classList.add('tab--selected');
    if (idOfContentElement === 'units-for-rent-content') {
      new AdFormService().impressionProjectListings(this.pageData, 2);
      this.loadUnits(this.pageData.id, 1, 'rent').then(() => {
        this.hideLoader()
        if (tabContent) tabContent.style.display = 'block'
      })
    } else {
      new AdFormService().impressionProjectListings(this.pageData, 1);
      this.loadUnits(this.pageData.id, 1, 'sale').then(() => {
        this.hideLoader()
        if (tabContent) tabContent.style.display = 'block'
      })
    }
  };

  private showLoader() {
    if (this.loader) {
      this.loader.style.display = 'block';
    }
  }

  private hideLoader() {
    if (this.loader) {
      this.loader.style.display = 'none';
    }
  }

  private clearSelection = () => {
    this.clearContent('units-for-sale-content');
    this.clearContent('units-for-rent-content');
    this.saleTabContent.classList.remove('tab--selected');
    this.rentTabContent.classList.remove('tab--selected');
  };


  private clearContent(elementId: string) {
    let element = document.getElementById(elementId);
    if(element) {
        element.style.display = 'none';
    }
  }

  private loadUnits = async (projectId: string, page: number, operationType: string) => {
    const html = await new ProjectUnitsService().getProjectUnits(projectId,
        page,
        operationType,
        this.publisherId,
        this.projectPagePath,
        this.isNewDevelopment,
    );

    document.getElementById(operationType != 'sale' ? 'unitsSaleList' : 'unitsRentList')!.innerHTML = '';
    document.getElementById(operationType == 'sale' ? 'unitsSaleList' : 'unitsRentList')!.innerHTML = html;

    this.updateNumberOfUnitsInTabs();

    const pageButtons = Array.from(document.getElementsByClassName('page-number'));

    pageButtons.forEach((pageButton) => {
      pageButton.addEventListener('click', () => {
        const numberButton = pageButton.getAttribute('data-page-number');
        // @ts-ignore
        this.loadUnits(projectId, numberButton, operationType);
      });
    });

    const arrowButtons = Array.from(document.getElementsByClassName('prev-button'));

    arrowButtons.forEach((arrowButton) => {
      arrowButton.addEventListener('click', () => {
        if (arrowButton.classList.contains('left') && page > 1) {
          this.loadUnits(projectId, parseInt(String(page)) - 1, operationType);
        }

        const lastPage = parseInt(pageButtons[pageButtons.length - 1].getAttribute('data-page-number')!);

        if (arrowButton.classList.contains('right') && page < lastPage) {
          this.loadUnits(projectId, parseInt(String(page)) + 1, operationType);
        }
      });
    });

    ContactModal.setup(this.pageData);
  };

  private updateNumberOfUnitsInTabs = () => {
    const numberOfSellUnits = Array.from(document.getElementById('unitsSaleList')!.querySelectorAll('[data-unitrow="true"]'));
    const numberOfRentUnits = Array.from(document.getElementById('unitsRentList')!.querySelectorAll('[data-unitrow="true"]'));
    this.saleTabContent.innerText = this.saleTabContent.innerText.replace('{TOTAL_SALE_UNITS}', numberOfSellUnits.length.toString());
    this.rentTabContent.innerText = this.rentTabContent.innerText.replace('{TOTAL_RENT_UNITS}', numberOfRentUnits.length.toString());
  }
}
